import { Button, Form, Input } from 'antd'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changePassword, logoutUser } from './store/store'
import { resetPasswordState } from './store/password'
import { ErrorMessage } from './ErrorMessage'
import { SuccessMessage } from './SuccessMessage'
import PasswordRecovery from './PasswordRecovery'

function ViewSettingsProfilePassword() {
  const dispatch = useDispatch()
  const password = useSelector(state => state.password)

  useEffect(() => {
    dispatch(resetPasswordState())
  }, [dispatch])

  useEffect(() => {
    if (password.success) {
      logoutUser()
    }
  }, [password.success])

  const handleSubmit = (values) => {
    // changePassword() dispatches internally (store.js wrapper pattern); it
    // must not be wrapped in dispatch() again or Redux #7 is thrown.
    changePassword({
      current_password: values.current_password,
      new_password: values.new_password
    })
  }

  return (
    <div>
      <Form
        name="change-password"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label="Текущий пароль"
          name="current_password"
          rules={[{ required: true, message: 'Введите текущий пароль' }]}
        >
          <Input.Password autoComplete="current-password" />
        </Form.Item>

        <Form.Item
          label="Новый пароль"
          name="new_password"
          hasFeedback
          rules={[{ required: true, message: 'Введите новый пароль' }]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>

        <Form.Item
          label="Подтверждение пароля"
          name="confirm_password"
          dependencies={['new_password']}
          hasFeedback
          rules={[
            { required: true, message: 'Введите пароль еще раз для подтверждения' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new_password') === value) {
                  return Promise.resolve()
                }

                return Promise.reject(new Error('Пароли, введенные Вами, не совпадают'))
              }
            })
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>

        <ErrorMessage error={ password.error } />
        <SuccessMessage message={ password.success && 'Пароль изменён. Войдите заново.' } />

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit" loading={ password.isLoading }>
            Сменить пароль
          </Button>
        </Form.Item>
      </Form>
      <PasswordRecovery />
    </div>
  )
}

export default ViewSettingsProfilePassword
